import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.scss';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const label = isDarkMode ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      className={`theme-toggle ${isDarkMode ? 'dark' : 'light'}`}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      <i className="fas fa-sun theme-toggle__sun" />
      <i className="fas fa-moon theme-toggle__moon" />
    </button>
  );
};

export default ThemeToggle;
